import { StringKey } from '../../lang/index';
import { NotificationType } from '../../types/notification.types';

export enum ActivityType {
  GET_STARTED = 'get-started',
  RESOLVED = 'resolved',
}

export type ActivityVariant = ActivityType | NotificationType;

export const activityVariantTitle: Record<ActivityType | NotificationType, StringKey> = {
  [ActivityType.GET_STARTED]: 'GET_STARTED',
  [NotificationType.ACTIVITY]: 'ACTIVITY',
  [NotificationType.REQUEST]: 'REQUESTS',
  [ActivityType.RESOLVED]: 'RESOLVED',
};

export const activityVariantMap = Object.entries(activityVariantTitle);
